export const bfhsupporter24: string[] = [
    "https://gasb.de/wp-content/uploads/2021/06/GASB.gif",
    "https://static.igem.wiki/teams/5833/sponsoring/promega-logo.webp",
    "https://static.igem.wiki/teams/5833/sponsoring/zymo-neuere-version.webp",
    "https://static.igem.wiki/teams/5833/sponsoring/uni-bielefeld-dunkel-neuneu.webp",
    "https://www.mn-net.com/media/image/bb/62/25/MN_Raute.png",
    "https://static.igem.org/websites/common/2022/logos/igem-logo-dark.svg",
    "https://static.igem.wiki/teams/5247/sponsors/plasmidfactory.png",
    "https://static.igem.wiki/teams/5247/sponsors/gip.png",
    "https://static.igem.wiki/teams/5247/sponsors/jbs-dunkelgruen-text.png",
    "https://static.igem.wiki/teams/5247/sponsors/cell-signaling-technology-logo.png",
    "https://www.fiz-biotech.de/fileadmin/templates/fiz/img/fiz_logo_schwarz.png",
    "https://static.igem.wiki/teams/5247/sponsors/campus-brauerei.png",
    "https://static.igem.wiki/teams/5247/sponsors/bts.png",
    "https://static.igem.wiki/teams/5247/sponsors/asimov-colorful.png",
    "https://static.igem.wiki/teams/5247/sponsors/algenium.png",
    "https://static.igem.wiki/teams/5247/sponsors/studscicom-logo.png"
]